module.exports = __webpack_public_path__ + "img/id-card-front-placeholder.b018bdaa.png";